module.exports = __webpack_public_path__ + "img/press-releases-card.48b52dec.png";